import { render } from "./ESign.vue?vue&type=template&id=e215d1c4"
import script from "./ESign.vue?vue&type=script&lang=ts"
export * from "./ESign.vue?vue&type=script&lang=ts"
script.render = render

export default script